import {
  INVENTARIZATION_LAYERS_CREATE,
  INVENTARIZATION_LAYERS_SHOW,
  INVENTARIZATION_LAYERS_HIDE,
  CHANGE_INVENTARIZATION_LAYERS_HEADERS,
  REDRAW_INVENTARIZATION_LAYERS
} from './actions.type';

import {
  TOGGLE_HISTORY_TIMELINE_ACTIVE,
  SET_HISTORY_TIMELINE_INVENTARIZATION,
  SET_HISTORY_TIMELINE_INVENTARIZATIONS,
  SET_HISTORY_TIMELINE_ORGANIZATION,
  LAYERS_LAYERS_ADD,
  SET_LAYER_VISIBILITY
} from './mutations.type';

import MapLayerBuilder from '../models/MapLayerBuilder';
import SettingsInstance from '../api/SettingsInstance';
const initialState = {
  historyTimelineActive: false,
  historyTimelineInventarization: '',
  historyTimelineOrganization: '',
  historyTimelineInventarizations: [],
  inventarizationLayers: [
    {
      id: 'inv_PUNKTOWA_ISTNIEJACA',
      name: 'pit:inv_PUNKTOWA_ISTNIEJACA',
      title: 'Infrastruktura techniczna i kanały technologiczne - punktowa'
    },
    {
      id: 'inv_LINIOWA_ISTNIEJACA',
      name: 'pit:inv_LINIOWA_ISTNIEJACA',
      title: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
    },
    {
      id: 'inv_POWIERZCHNIOWA_ISTNIEJACA',
      name: 'pit:inv_POWIERZCHNIOWA_ISTNIEJACA',
      title:
        'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
    },
    {
      id: 'inv_PUNKTOWA_PLANOWANA',
      name: 'pit:inv_PUNKTOWA_PLANOWANA',
      title: 'Plany inwestycyjne - infrastruktura punktowa'
    },
    {
      id: 'inv_LINIOWA_PLANOWANA',
      name: 'pit:inv_LINIOWA_PLANOWANA',
      title: 'Plany inwestycyjne - infrastruktura liniowa'
    },
    {
      id: 'inv_POWIERZCHNIOWA_PLANOWANA',
      name: 'pit:inv_POWIERZCHNIOWA_PLANOWANA',
      title: 'Plany inwestycyjne - infrastruktura powierzchniowa'
    },
    {
      id: 'inv_vwezly',
      name: 'pit:inv_vwezly',
      title: 'Węzły'
    },
    {
      id: 'inv_vpunkty_elastycznosci',
      name: 'pit:inv_vpunkty_elastycznosci',
      title: 'Punkty elastyczności'
    },
    {
      id: 'inv_vlinie_kablowe',
      name: 'pit:inv_vlinie_kablowe',
      title: 'Przebiegi linii kablowych'
    },
    {
      id: 'inv_vlinie_bezprzewodowe',
      name: 'pit:inv_vlinie_bezprzewodowe',
      title: 'Linie bezprzewodowe'
    },
    {
      id: 'inv_vstacje_bazowe',
      name: 'pit:inv_vstacje_bazowe',
      title: 'Stacje bazowe'
    },
    {
      id: 'inv_vbudynki_kolokacje',
      name: 'pit:inv_vbudynki_kolokacje',
      title: 'Budynki umożliwiające kolokację'
    },
    {
      id: 'inv_vuslugi_pkt_adr',
      name: 'pit:inv_vuslugi_pkt_adr',
      title: 'Usługi w punktach adresowych'
    }
  ]
};

const state = Object.assign({}, initialState);

function adaptInventarizationLayers(inventarizationLayers) {
  inventarizationLayers.forEach(inventarizationLayer => {
    inventarizationLayer.visible = false;
    inventarizationLayer.indeterminate = false;
    inventarizationLayer.type = 'WMTS';
    inventarizationLayer.url = `${SettingsInstance.geoserverUrl}/gwc/service/wmts`;
    inventarizationLayer.group = 'inventarizationLayers';
    // composition.valid = isLayerValid(composition);
  });
  return inventarizationLayers;
}
async function createMapLayer(context, layer) {
  let builder = new MapLayerBuilder(
    layer,
    null,
    context.getters.coordinateSystem
  );
  layer.mapLayer = await builder.getOlLayer(null, null, context);
}
export const actions = {
  async [INVENTARIZATION_LAYERS_CREATE](context) {
    state.inventarizationLayers = adaptInventarizationLayers(
      state.inventarizationLayers
    );
    state.inventarizationLayers.forEach(async layer => {
      // if (!layer.mapLayer) {
      await createMapLayer(context, layer);
      await context.commit(LAYERS_LAYERS_ADD, [layer]);
      // }
      layer.mapLayer.setZIndex(999);
      layer.order = 999;

      context.dispatch(CHANGE_INVENTARIZATION_LAYERS_HEADERS);
    });
  },
  async [INVENTARIZATION_LAYERS_SHOW](context) {
    state.inventarizationLayers.forEach(layer => {
      context.commit(SET_LAYER_VISIBILITY, {
        layerId: layer.id,
        visible: true
      });
    });
  },
  async [INVENTARIZATION_LAYERS_HIDE](context) {
    state.inventarizationLayers.forEach(layer => {
      context.commit(SET_LAYER_VISIBILITY, {
        layerId: layer.id,
        visible: false
      });
    });
  },
  async [CHANGE_INVENTARIZATION_LAYERS_HEADERS](context) {
    const filter = {};

    if (state.historyTimelineInventarization.trim()) {
      filter.inventory_id = state.historyTimelineInventarization;
    }
    if (
      state.historyTimelineOrganization &&
      state.historyTimelineOrganization !== '' &&
      parseInt(state.historyTimelineOrganization)
    ) {
      filter.org_id = state.historyTimelineOrganization;
    }
    if (Object.keys(filter) && Object.keys(filter).length) {
      state.inventarizationLayers.forEach(layer => {
        if (layer.mapLayer) {
          layer.mapLayer.setCqlFilter(filter);
        }
      });
    }
  },
  async [REDRAW_INVENTARIZATION_LAYERS](context) {
    const timeStampParam = 'timeStamp=' + Date.now();
    state.inventarizationLayers.forEach(layer => {
      if (layer.mapLayer) {
        const source = layer.mapLayer.getSource();
        const currentUrls = source.getUrls();

        // Clone the array to trigger a refresh
        // source.setUrls([...currentUrls]);
        const updatedUrls = currentUrls.map(url => {
          if (url.includes('timeStamp=')) {
            // Update the existing timeStamp parameter
            return url.replace(/timeStamp=\d+/, timeStampParam);
          } else {
            // Add the timeStamp parameter
            return url + (url.includes('?') ? '&' : '?') + timeStampParam;
          }
        });

        // Update the URLs
        source.setUrls(updatedUrls);
        // layer.mapLayer.getSource().clear();
        // layer.mapLayer.getSource().changed();
        // const wmtsSource = layer.mapLayer.getSource();
        // window.console.log(layer.mapLayer.getSource().getTileUrlFunction());
        // layer.mapLayer.getSource.setTileUrlFunction(
        //   layer.mapLayer.getSource().getTileUrlFunction()
        // );
        // layer.mapLayer.getSource().setUrl(layer.mapLayer.getSource().getUrl());
        // // Modify the source's parameters (e.g., change the tile matrix set or add a random parameter)
        // wmtsSource.updateParams({ time: Date.now() });

        // // Trigger a refresh of the layer
        // layer.mapLayer.redraw();
        // layer.mapLayer.getSource().refresh();
      }
    });
  }
};

const mutations = {
  [TOGGLE_HISTORY_TIMELINE_ACTIVE](state) {
    state.historyTimelineActive = !state.historyTimelineActive;
  },

  [SET_HISTORY_TIMELINE_INVENTARIZATION](state, value) {
    state.historyTimelineInventarization = value;
  },
  [SET_HISTORY_TIMELINE_INVENTARIZATIONS](state, value) {
    state.historyTimelineInventarizations = value;
  },
  [SET_HISTORY_TIMELINE_ORGANIZATION](state, value) {
    state.historyTimelineOrganization = value;
  }
};

const getters = {
  historyTimelineActive(state) {
    return state.historyTimelineActive;
  },
  historyTimelineInventarizations(state) {
    return state.historyTimelineInventarizations;
  },
  historyTimelineInventarization(state) {
    return state.historyTimelineInventarization;
  },
  inventarizationLayers(state) {
    return state.inventarizationLayers;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
